/**
 * Catalogue affichage admin Freemium (ordre = ordre des interrupteurs).
 * Les id doivent rester alignés avec backend/app/constants/premiumFeatures.js.
 * @module config/premiumFeaturesCatalog
 */

import { PREMIUM_FEATURE_IDS } from './constants';

export const PREMIUM_FEATURES_CATALOG = [
  {
    id: PREMIUM_FEATURE_IDS.REWARDS_MANAGEMENT,
    label: 'Récompenses',
    hint: 'Gestion des récompenses de chaîne',
  },
  {
    id: PREMIUM_FEATURE_IDS.SPOTIFY_INTEGRATION,
    label: 'Spotify',
    hint: 'File d’attente et contrôle Spotify',
  },
  {
    id: PREMIUM_FEATURE_IDS.FOLLOWED_CHANNELS,
    label: 'Chaînes suivies',
    hint: 'Suivi des chaînes Twitch suivies',
  },
  {
    id: PREMIUM_FEATURE_IDS.CHAT_MENTIONS,
    label: 'Mentions chat',
    hint: 'Mentions et notifications du chat',
  },
  {
    id: PREMIUM_FEATURE_IDS.FOLLOWS_SUBS,
    label: 'Follows & abonnés',
    hint: 'Statistiques follows et abonnements',
  },
  {
    id: PREMIUM_FEATURE_IDS.STREAM_STATS,
    label: 'Statistiques de stream',
    hint: 'Stats de diffusion',
  },
  {
    id: PREMIUM_FEATURE_IDS.BIRTHDAYS,
    label: 'Anniversaires',
    hint: 'Anniversaires des viewers',
  },
  {
    id: PREMIUM_FEATURE_IDS.CLIPS,
    label: 'Clips',
    hint: 'Gestion et affichage des clips',
  },
  {
    id: PREMIUM_FEATURE_IDS.OVERLAYS,
    label: 'Overlays',
    hint: 'Overlays et scènes',
  },
  {
    id: PREMIUM_FEATURE_IDS.BATTLE_VIEWERS,
    label: 'Battle viewers',
    hint: 'Battle 2 équipes en overlay (PV, commandes chat)',
  },
  {
    id: PREMIUM_FEATURE_IDS.PARAMETERS_PANEL,
    label: 'Paramètres',
    hint: 'Paramètres du bot, classement First, etc.',
  },
  {
    id: PREMIUM_FEATURE_IDS.ADVANCED_COMMANDS,
    label: 'Commandes avancées',
    hint: 'Édition des commandes et cooldowns',
  },
  {
    id: PREMIUM_FEATURE_IDS.AI_AUTO_INTERACTION,
    label: 'IA auto-interaction',
    hint: 'Configuration IA et interactions automatiques',
  },
];
